import React, { useState } from "react";
import "./addSlider.css";
import { addSlider } from "../../api/slider";
import { Cookies } from "react-cookie";

const AddSlider = (props) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    image: null,
    link: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      image: e.target.files[0],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const formBack = new FormData();
    formBack.append("image", formData.image);
    formBack.append("link", formData.link);
    formBack.append("user_type", props.user);
    addSlider(formBack).then((result) => {
      setFormData({
        image: null,
        link: "",
      });
      setLoading(false);
    });
  };

  return (
    <div className="add-brokers-guideline">
      <form onSubmit={handleSubmit}>
        {formData.image && (
          <img
            src={URL.createObjectURL(formData.image)}
            alt="Uploaded"
            style={{ maxWidth: "100%", marginTop: "10px" }}
          />
        )}
        <div className="form-group">
          <label htmlFor="image">Image</label>
          <input
            type="file"
            id="image"
            name="image"
            onChange={handleFileChange}
            accept="image/*"
            required
            onInvalid={(e) => e.target.setCustomValidity("Image is required")}
          />
        </div>

        <div className="form-group">
          <label htmlFor="link">Link</label>
          <input
            type="text"
            id="link"
            name="link"
            value={formData.link}
            onChange={handleChange}
            placeholder="Enter Link"
          />
        </div>
        {loading ? (
          <div
            style={{
              width: "100%",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <div className="spinner"></div>
          </div>
        ) : (
          <button type="submit" className="submit-button">
            Submit
          </button>
        )}
      </form>
    </div>
  );
};

export default AddSlider;
